import React from 'react';

export enum ButtonStyle {
  Save = 'save',
  Cancel = 'cancel',
  CancelDark = 'cancel-dark',
  Delete = 'delete',
  Edit = 'edit',
  Copy = 'copy',
}

export interface ButtonProps {
  text: string;
  beforeIcon?: string;
  afterIcon?: string;
  id?: string;
  className?: string;
  style: ButtonStyle;
  disabled?: boolean;
  onClick?(e: React.MouseEvent): void;
  onDisabledClick?(e: React.MouseEvent): void;
  name?: string;
  type?: 'button' | 'submit' | 'reset';
  value?: string;
}

const Button: React.SFC<ButtonProps> = props => (
  <button
    id={props.id}
    className={`button-v2 ${props.disabled ? 'disabled' : props.style} ${props.className || ''}`}
    onClick={e =>
      props.disabled ? props.onDisabledClick && props.onDisabledClick(e) : props.onClick && props.onClick(e)
    }
    value={props.value}
    name={props.name}
    type={props.type ? props.type : 'button'}
  >
    <span>
      {props.beforeIcon && <i className={`gik-icon-v2 icon-v2-${props.beforeIcon}`}></i>}
      &nbsp;
      {props.text}
      &nbsp;
      {props.afterIcon && <i className={`gik-icon-v2 icon-v2-${props.afterIcon}`}></i>}
    </span>
  </button>
);

export default Button;
